<template>
    <div class="row">
        <div class="col-lg-4  col-md-6 mb-1">
            <label class="form-label">Sözleşme Süresi (Ay)</label>
            <b-form-spinbutton min="1" max="36" v-model="value.AgreementDuration"></b-form-spinbutton> 
        </div>
        <div class="col-lg-4 col-md-6 mb-1">
            <label class="form-label">Vade (Gün)</label>
            <b-form-spinbutton min="7" max="365" step="1" v-model="value.Maturity"></b-form-spinbutton> 
        </div>
        <div class="col-lg-4 col-md-6 mb-1">
            <label class="form-label">Yakıt Değişim Oranı (%)</label>
            <b-form-spinbutton min="0" max="100" v-model="value.FuelPriceChangeRate"></b-form-spinbutton>  
        </div>
        <div class="col-lg-4 col-md-6 mb-1">
            <label class="form-label">Enflasyon Uygulama Süresi (Ay)</label>
            <b-form-spinbutton min="1" max="12"  v-model="value.InflationChangeDuration"></b-form-spinbutton> 
        </div>
        <div class="col-lg-4 col-md-6 mb-1">
            <label class="form-label">Teklif Geçerlilik Gün Sayısı</label>
            <b-form-spinbutton min="1" max="365" v-model="value.DraftOfferExpireDateCount"></b-form-spinbutton>
        </div>
        <div class="col-lg-4 col-md-6 mb-1">
            <div class="row">
                <div class="col-md-8">
                    <label class="form-label">Araç Bekleme Zaman Aşımı</label>
                    <b-form-spinbutton min="1" max="100" v-model="value.UnloadingTime"></b-form-spinbutton>
                </div>
                <div class="col-md-4">
                    <label class="form-label">Birim</label>
                    <select class="form-control" v-model="value.UnloadingTimeType">
                        <option v-for="type in unloadingTimeTypes" :key="type.value" :value="type.value">{{type.text}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-1">
            <label class="form-label">Araç Günlük Bekleme Ücreti</label>
            <input class="form-control" type="number" v-model="value.UnloadingTimeFaulPrice"/>
        </div>
        <div class="col-lg-4 col-md-6 mb-1">
            <label class="form-label">Araç Boş Taşıma Ücreti</label>
            <input class="form-control" type="number" v-model="value.EmptyTransportPrice"/>
        </div>
        <div class="col-lg-4 col-md-6 mb-1">
            <label class="form-label">Donmuş Ürün Sıcaklığı (°C)</label>
            <b-form-spinbutton min="-273" max="273" v-model="value.FrozenProductTemperature"></b-form-spinbutton>
        </div>
        <div class="col-lg-4 col-md-6 mb-1">
            <label class="form-label">Bekleme Referans Saati</label>
            <flat-pickr v-model="value.WaitReferenceTime" class="form-control" :config="{'enableTime': true,'noCalendar': true,'dateFormat': 'H:i', locale:'tr'}" placeholder="Başlangıç Tarihi"/>
        </div>
        <div class="col-lg-4 col-md-6 mb-1">
            <label class="form-label">Enflasyon Türü</label>
            <select class="form-control" v-model="value.InflationParameterType">
                <option v-for="type in enflationTyopes" :key="type.value" :value="type.value">{{type.text}}</option>
            </select>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-md-6 mb-1">
                    <label class="form-label">Birinci Bölüm</label>
                    <div class="bg-light p-1 rounded border">
                        <div class="row">
                            <div class="col-md-6 mb-md-0 mb-1">
                                <label class="form-label">Alt Sıcaklık (°C)</label>
                                <b-form-spinbutton min="-273" max="273" v-model="value.VehicleCompartment1TemperatureLowerLimit"></b-form-spinbutton>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label">Üst Sıcaklık (°C)</label>
                                <b-form-spinbutton min="-273" max="273" v-model="value.VehicleCompartment1TemperatureUpperLimit"></b-form-spinbutton>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mb-1">
                    <label class="form-label">İkinici Bölüm</label>
                    <div class="bg-light p-1 rounded border">
                        <div class="row">
                            <div class="col-md-6 mb-md-0 mb-1">
                                <label class="form-label">Alt Sıcaklık (°C)</label>
                                <b-form-spinbutton min="-273" max="273" v-model="value.VehicleCompartment2TemperatureLowerLimit"></b-form-spinbutton>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label">Üst Sıcaklık (°C)</label>
                                <b-form-spinbutton min="-273" max="273" v-model="value.VehicleCompartment2TemperatureUpperLimit"></b-form-spinbutton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-md-6 mb-1 mb-md-0">
                    <label class="form-label">Tutar Yansıtma Oranları</label>
                    <div class="bg-light p-1 rounded border">
                        <b-form-radio v-model="format" value="percentile" inline>Yüzdelik Format</b-form-radio>
                        <b-form-radio v-model="format" value="fraction" inline>Kesir Formatı</b-form-radio>
                        <hr class="mt-50 mb-50" />
                        <div v-if="format == 'percentile'" class="row">
                            <div class="col-md-6">
                                <label class="form-label form-label d-inline-flex w-100 justify-content-between">
                                    Yakıt
                                    <strong class="text-success">{{value.RateOfFuelPrice}}%</strong>
                                </label>
                                <b-form-spinbutton v-on:change="keep('fuel')" min="0" max="100" size="sm" v-model="value.RateOfFuelPrice"></b-form-spinbutton>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label form-label d-inline-flex w-100 justify-content-between">
                                    Enflasyon
                                    <strong class="text-success">{{value.RateOfInflationPrice}}%</strong>
                                </label>
                                <b-form-spinbutton v-on:change="keep('inflation')" min="0" max="100" size="sm" v-model="value.RateOfInflationPrice"></b-form-spinbutton>
                            </div>
                        </div>
                        <div v-else class="row">
                            <div class="col-md-6">
                                <label class="form-label d-inline-flex w-100 justify-content-between">
                                    Yakıt
                                    <strong class="text-success">{{value.FractionNumeratorOfFuelPrice}}/{{value.FractionDenominator}}</strong>
                                </label>
                                <div class="row">
                                    <div class="col-md-6">
                                        <b-form-spinbutton v-on:change="keep('fuel')" min="0" :max="value.FractionDenominator" size="sm" v-model="value.FractionNumeratorOfFuelPrice"></b-form-spinbutton>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-spinbutton v-on:change="keep('fuel');reset()" min="1" max="100" size="sm" v-model="value.FractionDenominator"></b-form-spinbutton>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label d-inline-flex w-100 justify-content-between">
                                    Enflasyon
                                    <strong class="text-success">{{value.FractionNumeratorOfInflationPrice}}/{{value.FractionDenominator}}</strong>
                                </label>
                                <div class="row">
                                    <div class="col-md-6">
                                        <b-form-spinbutton v-on:change="keep('inflation')" min="0" :max="value.FractionDenominator" size="sm" v-model="value.FractionNumeratorOfInflationPrice"></b-form-spinbutton>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-spinbutton v-on:change="keep('inflation');reset()" min="1" max="100" size="sm" v-model="value.FractionDenominator"></b-form-spinbutton>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="mt-50 mb-50" />
                        <b-form-checkbox v-on:change="reset" v-model="value.IsCompletedToFullValue">Oranlar {{ format == 'fraction' ? 1 : 100}}'e tamamlansın</b-form-checkbox>
                    </div>
                </div>
                <div class="col-md-6 mb-1 mb-md-0" v-if="tuControl">
                    <label class="form-label">Tüfe / Üfe Yansıtma Oranları</label>
                    <div class="bg-light p-1 rounded border">
                        <b-form-radio v-model="tuFormat" value="percentile" inline>Yüzdelik Format</b-form-radio>
                        <b-form-radio v-model="tuFormat" value="fraction" inline>Kesir Formatı</b-form-radio>
                        <hr class="mt-50 mb-50" />
                        <div v-if="tuFormat == 'percentile'" class="row">
                            <div class="col-md-6">
                                <label class="form-label form-label d-inline-flex w-100 justify-content-between">
                                    Tüfe
                                    <strong class="text-success">{{value.RateOfTufe}}%</strong>
                                </label>
                                <b-form-spinbutton v-on:change="tuKeep('tufe')" min="0" max="100" size="sm" v-model="value.RateOfTufe"></b-form-spinbutton>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label form-label d-inline-flex w-100 justify-content-between">
                                    Üfe
                                    <strong class="text-success">{{value.RateOfUfe}}%</strong>
                                </label>
                                <b-form-spinbutton v-on:change="tuKeep('ufe')" min="0" max="100" size="sm" v-model="value.RateOfUfe"></b-form-spinbutton>
                            </div>
                        </div>
                        <div v-else class="row">
                            <div class="col-md-6">
                                <label class="form-label d-inline-flex w-100 justify-content-between">
                                    Tüfe
                                    <strong class="text-success">{{value.FractionNumeratorOfTufe}}/{{value.TufeUfeFractionDenominator}}</strong>
                                </label>
                                <div class="row">
                                    <div class="col-md-6">
                                        <b-form-spinbutton v-on:change="tuKeep('tufe')" min="0" :max="value.TufeUfeFractionDenominator" size="sm" v-model="value.FractionNumeratorOfTufe"></b-form-spinbutton>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-spinbutton v-on:change="tuKeep('tufe');tuReset()" min="1" max="100" size="sm" v-model="value.TufeUfeFractionDenominator"></b-form-spinbutton>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label d-inline-flex w-100 justify-content-between">
                                    Üfe
                                    <strong class="text-success">{{value.FractionNumeratorOfUfe}}/{{value.TufeUfeFractionDenominator}}</strong>
                                </label>
                                <div class="row">
                                    <div class="col-md-6">
                                        <b-form-spinbutton v-on:change="tuKeep('ufe')" min="0" :max="value.TufeUfeFractionDenominator" size="sm" v-model="value.FractionNumeratorOfUfe"></b-form-spinbutton>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-spinbutton v-on:change="tuKeep('ufe');tuReset()" min="1" max="100" size="sm" v-model="value.TufeUfeFractionDenominator"></b-form-spinbutton>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="mt-50 mb-50" />
                        <b-form-checkbox v-on:change="tuReset" v-model="value.IsTufeUfeCompletedToFullValue">Oranlar {{ tuFormat == 'fraction' ? 1 : 100}}'e tamamlansın</b-form-checkbox>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/l10n/tr.js' 
import { BFormCheckbox, BFormRadio, BFormSpinbutton } from 'bootstrap-vue'
export default {
    components:{
        flatPickr,
        BFormRadio,
        BFormCheckbox,
        BFormSpinbutton
    },
    props:{
        value:Object
    },
    data(){
        return{
            enflationTyopes:[
                {value:0,text:"Aylık Değişim"},
                {value:1,text:"Bir Önceki Yılın Aralık Ayı"},
                {value:2,text:"Endeks"},
            ],
            unloadingTimeTypes:[
                {value:0,text:"Saat"},
                {value:1,text:"Gün"},
            ]
        }
    },
    methods:{
        keep(type){
            if(this.format == 'percentile'){
                if(this.value.IsCompletedToFullValue || this.value.RateOfInflationPrice + this.value.RateOfFuelPrice > 100){
                    if(type == 'fuel') this.value.RateOfInflationPrice = 100 - this.value.RateOfFuelPrice
                    if(type == 'inflation') this.value.RateOfFuelPrice = 100 - this.value.RateOfInflationPrice
                }
            }else{
                if(this.value.IsCompletedToFullValue || this.value.FractionNumeratorOfInflationPrice + this.value.FractionNumeratorOfFuelPrice > this.value.FractionDenominator){
                    if(type == 'fuel') this.value.FractionNumeratorOfInflationPrice = this.value.FractionDenominator - this.value.FractionNumeratorOfFuelPrice
                    if(type == 'inflation') this.value.FractionNumeratorOfFuelPrice = this.value.FractionDenominator - this.value.FractionNumeratorOfInflationPrice
                }
            }
        },
        tuKeep(type){
            if(this.tuFormat == 'percentile'){
                if(this.value.IsTufeUfeCompletedToFullValue || this.value.RateOfUfe + this.value.RateOfTufe > 100){
                    if(type == 'tufe') this.value.RateOfUfe = 100 - this.value.RateOfTufe
                    if(type == 'ufe') this.value.RateOfTufe = 100 - this.value.RateOfUfe
                }
            }else{
                if(this.value.IsTufeUfeCompletedToFullValue || this.value.FractionNumeratorOfTufe + this.value.FractionNumeratorOfUfe > this.value.TufeUfeFractionDenominator){
                    if(type == 'tufe') this.value.FractionNumeratorOfUfe = this.value.TufeUfeFractionDenominator - this.value.FractionNumeratorOfTufe
                    if(type == 'ufe') this.value.FractionNumeratorOfTufe = this.value.TufeUfeFractionDenominator - this.value.FractionNumeratorOfUfe
                }
            }
        },
        reset(){
            if(this.format == 'percentile'){
                this.value.RateOfInflationPrice = 50
                this.value.RateOfFuelPrice = 50
            }
            else{
                this.value.FractionNumeratorOfInflationPrice = Math.ceil(this.value.FractionDenominator / 2)
                this.value.FractionNumeratorOfFuelPrice = Math.floor(this.value.FractionDenominator / 2)
            }
        },
        tuReset(){
            if(this.tuFormat == 'percentile'){
                this.value.RateOfUfe = 50
                this.value.RateOfTufe = 50
            }
            else{
                this.value.FractionNumeratorOfTufe = Math.ceil(this.value.TufeUfeFractionDenominator / 2)
                this.value.FractionNumeratorOfUfe = Math.floor(this.value.TufeUfeFractionDenominator / 2)
            }
        }
    },
    computed:{
        format:{
            get(){ return this.value.IsHaveFraction ? 'fraction' : 'percentile' },
            set(value){ this.value.IsHaveFraction = value == 'percentile' ? false : true}
        },
        tuFormat:{
            get(){ return this.value.IsTufeUfeHaveFraction ? 'fraction' : 'percentile' },
            set(value){ this.value.IsTufeUfeHaveFraction = value == 'percentile' ? false : true}
        },
        tuControl(){
            if(this.format == 'fraction' && this.value.FractionNumeratorOfInflationPrice == 0) return false
            else if(this.format == 'percentile' && this.value.RateOfInflationPrice == 0) return false
            else return true
        }
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>